export default __webpack_public_path__ + "static/media/predictorImg.26422897.png";